import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
// import { useTranslation } from 'react-i18next';
import { PropertyPortfolioTagLabel } from 'src/components/shared/PropertyPortfolioTagLabel';
import { Grid } from '@mui/material';
import { AssignPortfoliosToPropertyModal } from 'src/pages/NewBillingModule/AssignPortfoliosToPropertieModal';
export const PropertyPortfolioTagsBlock = observer(_ref => {
  let addPortfolioEnabled = _ref.addPortfolioEnabled,
    propertyProps = _ref.propertyProps,
    _ref$propertySelected = _ref.propertySelectedPortfolioListIds,
    propertySelectedPortfolioListIds = _ref$propertySelected === void 0 ? [] : _ref$propertySelected,
    updateSelectedPortfoliosCallBack = _ref.updateSelectedPortfoliosCallBack,
    removePortfolioActionHandler = _ref.removePortfolioActionHandler,
    isLoading = _ref.isLoading,
    propertyAddress = _ref.propertyAddress;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const classes = useStyles();
  const store = useStore();
  // const { t } = useTranslation();

  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAssignPortfolioToPropertyModalOpen = _useState2[0],
    setIsAssignPortfolioToPropertyModalOpen = _useState2[1];
  const PortfolioLabelsList = observer(() => {
    const listResult = [];
    if (!!(propertySelectedPortfolioListIds !== null && propertySelectedPortfolioListIds !== void 0 && propertySelectedPortfolioListIds.length)) {
      listResult.push(...propertySelectedPortfolioListIds.filter(i => !!i).slice().sort((a, b) => {
        var _ref2, _store$homeDashboardS, _store$homeDashboardS2;
        return (_ref2 = '' + ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyPortfolioDataDetails(a)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.name)) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyPortfolioDataDetails(b)) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.name, undefined, {
          numeric: true
        });
      }).sort((a, b) => {
        var _store$homeDashboardS3, _store$homeDashboardS4, _store$homeDashboardS5;
        if (((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.companyPortfolioDataDetails(a)) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.isDefault) === ((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.companyPortfolioDataDetails(b)) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.isDefault)) return 0;
        return (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS5 !== void 0 && (_store$homeDashboardS5 = _store$homeDashboardS5.companyPortfolioDataDetails(a)) !== null && _store$homeDashboardS5 !== void 0 && _store$homeDashboardS5.isDefault ? -1 : 1;
      }).filter(i => {
        var _store$homeDashboardS6;
        const matchingPortfolio = (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.companyPortfolioDataDetails(i);
        if (!(store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin || store.account.userProfile.isUserPropertyManagerAccountHolder)) {
          return !(matchingPortfolio !== null && matchingPortfolio !== void 0 && matchingPortfolio.isDefault);
        } else {
          return true;
        }
      }).map(i => {
        var _store$homeDashboardS7;
        const matchingPortfolio = (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.companyPortfolioDataDetails(i);
        const portfolioData = _objectSpread({}, matchingPortfolio);
        if (!(portfolioData !== null && portfolioData !== void 0 && portfolioData.id)) return null;
        return /*#__PURE__*/React.createElement(Grid, {
          item: true
        }, /*#__PURE__*/React.createElement(PropertyPortfolioTagLabel, {
          key: "portfolio-label-".concat(portfolioData.id),
          iconName: 'folder-house',
          labelText: portfolioData.name,
          isRemoveBtn: !portfolioData.isDefault,
          propertyProps: propertyProps,
          removeActionCallback: () => {
            removePortfolioActionHandler(portfolioData.id);
          },
          propertyAddress: propertyAddress
        }));
      }));
    }
    if (addPortfolioEnabled) {
      listResult.push(/*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(PropertyPortfolioTagLabel, {
        key: "add-new-portfolio-label",
        iconName: 'folder-house',
        isLoaderPlaceholder: store.portfolios.getExistingPortfoliosAsync.inProgress,
        labelText: 'Add new portfolio',
        isRemoveBtn: false,
        isAddNew: true,
        propertyAddress: propertyAddress,
        addNewActionCallback: () => {
          setIsAssignPortfolioToPropertyModalOpen(true);
        }
      })));
    }
    return listResult;
  });
  const LoadingState = observer(() => {
    return Array.from({
      length: 3
    }, (_, i) => /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: "Loading-Portfolio-Label-".concat(i)
    }, /*#__PURE__*/React.createElement(PropertyPortfolioTagLabel, {
      isLoaderPlaceholder: true
    })));
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: 'row',
    columnSpacing: 2,
    rowSpacing: 2
  }, isLoading ? /*#__PURE__*/React.createElement(LoadingState, null) : /*#__PURE__*/React.createElement(PortfolioLabelsList, null), /*#__PURE__*/React.createElement(AssignPortfoliosToPropertyModal, {
    key: 'PropertyCreate_AssignPortfoliosToPropertyModalKey',
    externalIsOpen: isAssignPortfolioToPropertyModalOpen,
    callback: data => {
      console.log('AssignPortfoliosToPropertyModal callback', data);
      if (data.action === 'submit') {
        // fetchPropertyInformation();
        updateSelectedPortfoliosCallBack(data.data.portfolioIds);
      }
      setIsAssignPortfolioToPropertyModalOpen(false);
      // getExistingPortfolioId();
    },
    currentProperty: null,
    externalPortfolioList: propertySelectedPortfolioListIds,
    propertyAddress: propertyAddress
  }));
});